import template from './fixedFeeBasisModificationModal.html';
import controller from './fixedFeeBasisModificationModal.controller';

let fixedFeeBasisModificationModal = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'hmodal-info animated zoomIn'
};

export default fixedFeeBasisModificationModal;



// WEBPACK FOOTER //
// ./client/common/modals/fixedFeeBasisModificationModal/fixedFeeBasisModificationModal.component.js